import { Stack } from '@mui/material';
import React from 'react';
import { ITableSort } from '../common/interfaces/common.interface';
import SearchInput from './SearchInput';

const TableHeader: React.FC<{
  sortOptions: ITableSort[];
  filters?: boolean;
  openModal?: () => void;
  setSearchValue: (searchValue: string) => void;
  searchTitle: string;
}> = ({ sortOptions, filters, openModal, setSearchValue, searchTitle }) => {
  const handleSearchChange = (searchValue: string) => {
    setSearchValue(searchValue);
  };
  return (
    <Stack
      sx={{
        px: '20px',
        py: 2,
        width: '35%',
        minWidth: '340px'
      }}
      direction={'row'}
      alignItems="center"
      spacing={2}
    >
      <SearchInput icon setSearchValue={handleSearchChange} searchTitle={searchTitle} />
    </Stack>
  );
};

export default TableHeader;
